import styled from "styled-components";

export const OuterContainer = styled.div`
  background-color: #f5f5f5;
  position: relative;
  width: 100%;
  padding: 15px 15.4vw 21px;

  @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
    background-color: transparent;

    border-top: 1px solid #e5e5e5;
  }
`;

export const InnerContainer = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 10px;
`;

export const List = styled.ul`
  display: flex;
  margin: 0;
  padding: 0;

  transition: transform 0.2s ease-in-out;
  transform: translateX(${(props) => props.scrollPos}px);

  & > li {
    list-style: none;

    &:not(:last-child) {
      margin-right: 4px;
    }
  }
`;
